module.exports = __webpack_public_path__ + "img/2cb80c6e48e6af88e752c5c4d31c2bae.da658a0b.jpg";